
<script>
import Vue from "vue";
import func from "../../libs/functions.js";

import { mapGetters, mapActions } from "vuex";

import { supabase } from "../../libs/supabaseClient";

import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css';

import _ from "lodash";

import _system from "../../libs/system";

import { _is } from './mixins/_is'
import { getPlatformImage } from './mixins/getPlatformImage'

import { Datetime } from "vue-datetime";

Vue.component("datetime", Datetime);
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "Export",
  mixins: [_is, getPlatformImage],
  data() {
    return {
      getExportFiltering: {			
        after: '',
        before: '',
        reverse: false,
        pageIds : [],
        tags : [],
        notTags : [],
        assignedTo: []
    },
    tagsFilteringLogic: '_and',
    exportFiles: [],
    file: {
      name: ''
    },
    startDate: '',
    endDate: '',
    currentDate: '',
    allTagz: []
    };
  },
  computed: {
    ...mapGetters("workspaces", ["workspaces", "currentWorkspace"]),
    ...mapGetters("session", ["isLoggedIn", "getUser"]),
    ...mapGetters('tags', ['tags', 'getEnumaratedTags', 'tagsByName', 'tagsByTypeName','tagsByName', 'tagsById']),
    ...mapGetters("workspaces", ["workspaces", "currentWorkspace"]),
    ...mapGetters("accounts", ["accounts", "accountsById", "workspaceAccountsById"]),
    ...mapGetters("networks", ["networksById"]),
    ...mapGetters('htmlModals', ['modals']),
    ...mapGetters('inboxFilters', ['getInboxFilters', 'getInboxFiltersPageId', 'getInboxFiltersStatusId']),
    onlyActiveAccounts() {
      let onlyActivePages = _.filter(this.accounts, account => {
        if ((account.tags && account.tags.indexOf(this.tagsByName["Passive"]._id) == -1) || !account.tags) return account;
      });
      return onlyActivePages;
    },
    menu(){
            let menu = [
            {
              title: 'Status',
              type: 'radio',
              data: [{
                name: 'Open',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'notTagId',
                isActive: () => { 
                  return _.includes(this.getExportFiltering.notTags, this.getEnumaratedTags.Archived._id) && 'selected'
                },
                setFilter: () => {
                  if(this.getExportFiltering.notTags.includes(this.getEnumaratedTags.Archived._id)){
                    return;
                    //return this.fetch_messages();
                  }
                  this.getExportFiltering.tags = _.remove(this.getExportFiltering.tags, (n)=> n !== this.getEnumaratedTags.Archived._id);
                  this.getExportFiltering.notTags.push(this.getEnumaratedTags.Archived._id);
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              },{
                name: 'Archived',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'tagId',
                isActive: () => {

                  return _.includes(this.getExportFiltering.tags, this.getEnumaratedTags.Archived._id) && 'selected'
                  },
                setFilter: () => {
                  this.getExportFiltering.notTags = _.remove(this.getExportFiltering.notTags, (n)=> n !== this.getEnumaratedTags.Archived._id);
                  this.getExportFiltering.tags.push(this.getEnumaratedTags.Archived._id)
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              }]
            },
            {
              title: 'Order by',
              type: 'radio',
              data: [{
                name: 'Newest to oldest',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'tagId',
                isActive: () => {
                    if(this.getExportFiltering.reverse === false){
                      return 'selected'
                    }
                  },
                setFilter: () => {
                  return;
                  //this.setInboxFiltersReverse(false);
                  //return this.fetch_messages();
                }
              },{
                name: 'Oldest to newest',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'notTagId',
                isActive: () => { 
/*                   console.log('Oldest to newest')
                  console.log(this.getExportFiltering.reverse)
                  console.log((this.getExportFiltering.reverse === true)) */

                    if(this.getExportFiltering.reverse === true){
                      return 'selected'
                    }

                },
                setFilter: () => {
                  return;
                  //this.setInboxFiltersReverse(true);
                  //console.log(this.getExportFiltering.reverse)
                  //return this.fetch_messages();
                }
              }]
            },
            {
              title: 'Filtering',
              type: 'select',
              data: [{
                name: 'Assigned To Me',
                queryParam: 'assigneeId',
                icon: 'user circle icon',
                disabled:  false,
                isActive: () => {
                  if(this.getExportFiltering.assignedTo.length && !this.getExportFiltering.assignedTo.includes('!')){
                    return 'checked' 
                  }
                },
                setFilter: () => {
                  if(this.getExportFiltering.assignedTo.length){
                    this.getExportFiltering.assignedTo = [];
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }
                  this.getExportFiltering.assignedTo.push(this.getUser._id)
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              },
              {
                name: 'Unassigned',
                queryParam: 'assigneeId',
                icon: 'user times icon',
                disabled: false,
                isActive: () => {
                  return this.getExportFiltering.assignedTo.includes('!') && 'checked'
                },
                setFilter: () => {
                  if(this.getExportFiltering.assignedTo.length){
                    this.getExportFiltering.assignedTo = []
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }

                  this.getExportFiltering.assignedTo.push('!')
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              }]
            },
            {
              title: 'Channels',
              type: 'select',
              data: () => {
                
                let arr = [];

                arr.push({
                _type: 'All Channels',
                name: 'All Channels',
                queryParam: '',
                icon: 'list alternate outline icon',
                visibility: false,
                isActive: () => {
                  return !this.getExportFiltering.pageIds.length && 'checked'
                },
                setFilter: () => {
                  this.getExportFiltering.pageIds = []
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              })

              let channels = _.map(this.accounts, (item) => {
                  item._type = 'channel'
                  item.queryParam = 'pageId'

                  
                  //custom by user email
                  if(this.getUser.email.includes('upchannels.com')){
                    item.name = item.name.substring(0,29);
                  }else{
                    item.name = item.name.substring(0,19);
                  }

                  item.reAuth = () => {

                    if(item.tags && item.tags.includes(this.tagsByName['Passive']._id) && item.tags.includes('610d429248da7e774801c9e9')){
                      return {
                        id: 'instagram',
                        page: item,
                        active: true,
                        content: 'Instagram needs messages permission to be activated!'
                      }
                    }else if(item.tags && item.tags.includes(this.tagsByName['Passive']._id)){
                       return {
                        id: 'default',
                        page: item,
                        active: true,
                        content: 'Access token nees to be refreshed!'
                      }
                    }

                    //(item.tags && item.tags.indexOf(this.tagsByName['Passive']._id) == -1) ? false : true
                    return {
                      id: '0',
                      active: false,
                      content: ''
                    }
                  }
                  item.setFilter = () => {
                  if(_.includes(this.getExportFiltering.pageIds, item._id)){
                    this.getExportFiltering.pageIds = _.remove(this.getExportFiltering.pageIds, (n)=> n !== item._id);
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }
                    this.getExportFiltering.pageIds.push(item._id)
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                   //return this.fetch_messages();
                  }
                   item.isActive =  () => {
                    return _.includes(this.getExportFiltering.pageIds, item._id) && 'checked'
                  }
                  return item
                })

                arr = arr.concat(channels);

                return arr
              }
            },
            {
              title: 'Ratings',
              type: 'radio',
              dataRatings: () => {

                let ratings = _.filter(this.tagsByTypeName['DefaultMessageTag'], (t) => t.name.includes('Star'));

                return _.map(ratings, (item) => {
                  item.queryParam = 'tagId'
                  item.setFilterRatings = () => {
                  
                  //If clicked rating exist then remove it and render
                  if(_.includes(this.getExportFiltering.tags, item._id)){
                    this.getExportFiltering.tags = _.remove(this.getExportFiltering.tags, (n)=> n !== item._id);
                    this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                      return this.fetch_messages();
                  }
 
                  //if another rating is clicked
                    this.getExportFiltering.tags.push(item._id)
                    this.setInboxFilters(Object.assign({}, this.getExportFiltering ));

                    let unselectedRatings = _.filter(ratings, (i) => i._id !== item._id);
                      unselectedRatings = _.map(unselectedRatings, (e) => e._id)

                      _.map(unselectedRatings, (tag) => {
                        this.getExportFiltering.tags = _.remove(this.getExportFiltering.tags, (n)=> n !== tag);
                      });

                      return this.fetch_messages(+ new Date() - 1000*60*60*24*30);
                  }
                  item.isActiveRatings = () => {
                     return _.includes(this.getExportFiltering.tags, item._id) && 'active'
                  }

                  return item;
                });
               
              }
            },
            {
              title: 'Tags',
              type: 'select',
              data: () => {

                
                let allTags = [];

                if(this.currentWorkspace.userTags && this.currentWorkspace.userTags.length){

                let customTagsClone =  Object.assign({}, this.currentWorkspace.userTags);

                    customTagsClone = _.map(this.currentWorkspace.userTags, (tag) =>{
                                        tag.customTag = true;
                                        return tag
                                      }) 

                  allTags = this.tagsByTypeName['DefaultMessageTag'].concat(customTagsClone);
                }else{
                  allTags = this.tagsByTypeName['DefaultMessageTag']
                }

                this.allTagz = allTags;

                 let updatedArray = _.map(allTags, (item) => {
                  item.queryParam = 'tagId'
                  item.color = (item.color && item.color.length) ? item.color : '#d6d6d6';
                  item.setFilter = () => {
                  if(_.includes(this.getExportFiltering.tags, item._id)){
                    return this.getExportFiltering.tags = _.remove(this.getExportFiltering.tags, (n)=> n !== item._id);

                  }
                    this.getExportFiltering.tags.push(item._id)
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                      //return this.fetch_messages();
                  }
                  item.isActive = () => {
                     return _.includes(this.getExportFiltering.tags, item._id) && 'active'
                  }

                  if(item.customTag){
                    item.remove = () => {
                      let payload = {
                        query:{
                          workspaceId: this.currentWorkspace._id,
                          tagId: item._id
                        }
                      }
                      return _system.services.tags.removeTagFromCurrentWorkspace(payload, (err, res) => {
                        if(err) return alert(err.message)

                        return this.currentWorkspace.userTags = res.userTags
                      })
                    }
                  }

                  return item
                })

                //Add Custom Tag
                let commentTagObject = {
                  id: '123ı10djm2ıjd0phj',
                  name: 'All Comments',
                  visibility: false,
                  queryParam: 'notTagId',
                  isActive: () => { 
                    return _.includes(this.getExportFiltering.notTags, this.getEnumaratedTags.DirectMessage._id) && 'active'
                  },
                  setFilter: () => {
                    if(_.includes(this.getExportFiltering.notTags, this.getEnumaratedTags.DirectMessage._id)){
                      return this.getExportFiltering.notTags = _.remove(this.getExportFiltering.notTags, (n)=> n !== this.getEnumaratedTags.DirectMessage._id);
                      //return this.fetch_messages();
                    }
                    this.getExportFiltering.tags = _.remove(this.getExportFiltering.tags, (n)=> n !== this.getEnumaratedTags.DirectMessage._id);
                    this.getExportFiltering.notTags.push(this.getEnumaratedTags.DirectMessage._id);
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }
                }

                updatedArray.unshift(commentTagObject);


                updatedArray = _.map(updatedArray, (item) => {
                  if(item.name == 'All Comments' || item.name == 'Ads Comments' || item.name == 'Direct Message'){
                    item.messageType = true;
                  }

                  if(item.name == 'Direct Message'){
                    item.messageIsDm = true;
                  }


                  if([this.getEnumaratedTags.OneStar._id,this.getEnumaratedTags.TwoStar._id,this.getEnumaratedTags.ThreeStar._id,this.getEnumaratedTags.FourStar._id,this.getEnumaratedTags.FiveStar._id].includes(item._id)){
                    item.ratingsMenu = true;
                  }

                  //hide archied 
                  if(item.name == 'Archived'){
                    item.archived = true;
                  }

                  return item
                });
                
                return updatedArray
              }
            }
          ]

            //Custom Menu
            if(this.getUser.email.includes('designandprintagency.com') || this.getUser.email.includes('juphy2.com')){
              let filtering = _.find(menu, { title: 'Filtering' });
              console.log('f::', filtering);

              //AssignedToMe
              menu[1].data[0] = {
                name: 'Assigned To Me',
                queryParam: 'assigneeId',
                icon: 'user circle icon',
                disabled:  false,
                isActive: () => {
                  if(this.getExportFiltering.assignedTo.length && !this.getExportFiltering.assignedTo.includes('!')){
                    return 'checked' 
                  }
                },
                setFilter: () => {
                  if(this.getExportFiltering.assignedTo.includes(this.getUser._id)){
                    this.getExportFiltering.assignedTo = [];
                    this.getExportFiltering.assignedTo.push('!');
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }

                  if(this.getExportFiltering.assignedTo.includes('!')){
                    this.getExportFiltering.assignedTo = [];
                    this.getExportFiltering.assignedTo.push(this.getUser._id);
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }
                  

                  this.getExportFiltering.assignedTo.push(this.getUser._id);
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              }

              //Unassigned
              menu[1].data[1] = {
                name: 'Unassigned',
                queryParam: 'assigneeId',
                icon: 'user times icon',
                disabled: false,
                isActive: () => {
                  return this.getExportFiltering.assignedTo.includes('!') && 'checked'
                },
                setFilter: () => {
                  if(this.getExportFiltering.assignedTo.includes('!')){
                    console.log('Suan ! var')
                    this.getExportFiltering.assignedTo = [];
                    this.getExportFiltering.assignedTo.push(this.getUser._id)
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }

                  if(this.getExportFiltering.assignedTo.includes(this.getUser._id)){
                    console.log('Suan User var')
                    this.getExportFiltering.assignedTo = [];
                    this.getExportFiltering.assignedTo.push('!')
                    return;
                    //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                    //return this.fetch_messages();
                  }
                  
                  this.getExportFiltering.assignedTo.push('!')
                  return;
                  //this.setInboxFilters(Object.assign({}, this.getExportFiltering ));
                  //return this.fetch_messages();
                }
              }

            }

            return menu
          }
  },
  methods: {
    ...mapActions("htmlModals", ["setCreateSearchModal", "setConversationModalId", "setConversationModal"]),
    ...mapActions("tags", ["setTags"]),
    ...mapActions("workspaces", [
      "setWorkspaces",
      "pushWorkspace",
      "setCurrentWorkspace"
    ]),
    ...mapActions("workspaceusers", ["setWorkspaceusers"]),
    ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
    updateTime(){

  setTimeout( () => {
      this.getExportFiltering.after = new Date(this.startDate).getTime();
      this.getExportFiltering.before = new Date(this.endDate).getTime();
  }, 500)
},
filterInput() {
      const allowedChars = /[^a-zA-Z0-9_ ]/g; // Regular expression for non-allowed characters
      this.file.name = this.file.name.replace(allowedChars, '');
    },
renderDate(time){
      var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute:'2-digit' };
      var formattedTime  = new Date(time)

      if(Intl && Intl.DateTimeFormat() && Intl.DateTimeFormat().resolvedOptions() && Intl.DateTimeFormat().resolvedOptions().timeZone){
        options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      return formattedTime.toLocaleDateString("en-US", options)
    },
    download(){

      if(!this.file.name.length) return alert('Please type a file name.');

      if(!this.getExportFiltering.pageIds.length) return alert('Please select one or multiple channels.');

      let object = {
            ws_id: this.currentWorkspace._id,
            name: this.file.name,
            filterJson: this.getExportFiltering,
            file: '-',
            tagsEnum: { data: this.allTagz },
            pagesEnum: { data: this.accounts }
         }


         //Update OR _ AND Logic into Filter
         object.filterJson.tagsFilteringlogic = this.tagsFilteringLogic;

         //Set filteringString
         object.filterString = JSON.stringify(object.filterJson)

      supabase.from('csvFiles').upsert([object]).then(result => {
          this.exportFiles =  _.orderBy(this.exportFiles.concat([object]), ['created_at'] , ['desc'])

          this.file.name = '';
          iziToast.success({
              position: 'bottomCenter',
              title:  'Processing file can take up to 1-2 hours.'
          });
        })
        .catch(error => {

        console.error(error)
        });

    }
  },
  mounted() {
setInterval(() => {
    //Get export collections
    supabase.from('csvFiles').select('*').eq('ws_id', this.currentWorkspace._id).then(result => {
            this.exportFiles =  _.orderBy(result.data, ['created_at'] , ['desc'])
          })
          .catch(error => {
            // Handle insertion error
            console.error(error)
          });
}, 600000)


  },
  created() {
    this.getExportFiltering.notTags.push(this.getEnumaratedTags.Archived._id);

    this.getExportFiltering.notTags.push(this.getEnumaratedTags.DirectMessage._id);

    //DateData
    let currentSec = + new Date();
    let currentSecMinus30Days = currentSec - 1000*60*60*24*7;

    this.startDate = new Date( currentSecMinus30Days ).toISOString()
    this.endDate = new Date( currentSec + 86400000 ).toISOString()
    this.currentDate = new Date( currentSec + 86400000 ).toISOString()
    this.getExportFiltering.after = new Date(this.startDate).getTime();
    this.getExportFiltering.before = new Date(this.endDate).getTime();




    //Get export collections
    supabase.from('csvFiles').select('*').eq('ws_id', this.currentWorkspace._id).then(result => {
     
            this.exportFiles =  _.orderBy(result.data, ['created_at'] , ['desc'])
            this.exportFiles = this.exportFiles.map(item => {
              const filteredPageIds = item.filterJson.pageIds.filter(id => this.accountsById[id] !== undefined);
              return { ...item, filterJson: { ...item.filterJson, pageIds: filteredPageIds } };
            });
          })
          .catch(error => {
            // Handle insertion error
            console.error(error)
          });

  }
};
</script>

<template>

<div class="ui grid">
  <div class="eleven wide column centered">

<table class="ui striped table">
  <thead>
    <tr>
       <th>Exports</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="exportFile in exportFiles" :key="exportFile.id">
      <td>
        <div class="ui list">
  <div class="item export">
    <div class="description">
      <b>Name: </b> {{exportFile.name}}
    </div>
    <div class="description">
        <b>Pages: </b>
        <span v-for="page in exportFile.filterJson.pageIds" :key="page">
          <img :src="getPlatformImage(accountsById[page].platform)" style="bottom: 0px;width: 14px;height: 14px;border-radius: 20px; vertical-align: middle;left: -5.5px; border: 1px solid #fff;" alt="">
          <span :title="networksById[accountsById[page].platform].name" style="margin-bottom: 5px;  margin-right: 5px;" >{{ accountsById[page].name }}.</span> 
        </span>
        <span> <b>From: </b> {{ renderDate(exportFile.filterJson.after) }} </span>
        <span> <b>To: </b> {{ renderDate(exportFile.filterJson.before) }} </span>
        <p style="margin-top: 0.5rem;"><b>Tags: </b>
      <span class="ui small label" v-for="tag in exportFile.filterJson.tags" :key="tag">
           <span style="margin-bottom: 5px; margin-right: 5px;" >{{ tagsById[tag].name }}.</span> 
        </span> </p>
    </div>
    <div class="description">
      <b>Download: </b>
      <span v-if="exportFile.file == '-' && exportFile.count !== '0'" data-label="File">
        <i class="notched circle loading icon"></i> In Progress... 
      </span>
      <span v-if="exportFile.file == '--' && exportFile.count === '0'" data-label="File">
        <i class="minus icon"></i> (Comments do not exist within the specified date range.)
      </span>
      <span v-if="exportFile.file !== '--' && exportFile.count" data-label="File">
        <a :href="'https://widget.juphy.com/download/out_' + exportFile.file + '.csv'">{{exportFile.file}}</a>
      </span>
    </div>
  </div>
</div>
      </td>
    </tr>
  </tbody>
</table>



    <table class="ui celled striped table">
  <thead>
    <tr><th>Name</th>
    <th>File</th>
    <th>Tags and Pages</th>
    <th>Count</th>
  </tr></thead>
  <tbody>
    <tr v-for="exportFile in exportFiles" :key="exportFile.id" >
      <td data-label="Name">{{exportFile.name}}</td>
      <td v-if="exportFile.file == '-' && exportFile.count !== '0'" data-label="File">
        <i class="notched circle loading icon"></i> In Progress... 
      </td>
      <td v-if="exportFile.file == '--' && exportFile.count === '0'" data-label="File">
        <i class="minus icon"></i> (couldn't find any comments)
      </td>
      <td v-if="exportFile.file !== '--'" data-label="File">
        <a :href="'https://widget.juphy.com/download/out_' + exportFile.file + '.csv'">{{exportFile.file}}</a>
      </td>
      <td data-label="tags">
        <b>Tags: </b>
        <span v-for="tag in exportFile.filterJson.tags" :key="tag">
           <span style="margin-bottom: 5px; margin-right: 5px;" >{{ tagsById[tag].name }}.</span> 
        </span> 
        <div class="ui divider"></div>
        <b>Pages: </b>
        <span v-for="page in exportFile.filterJson.pageIds" :key="page">
          <img :src="getPlatformImage(accountsById[page].platform)" style="bottom: 0px;width: 14px;height: 14px;border-radius: 20px; vertical-align: middle;left: -5.5px; border: 1px solid #fff;" alt="">
          <span :title="networksById[accountsById[page].platform].name" style="margin-bottom: 5px;  margin-right: 5px;" >{{ accountsById[page].name }}.</span> 
        </span>
        <div class="ui divider"></div>
        <span> <b>From: </b> {{ renderDate(exportFile.filterJson.after) }} </span>
        <span> <b>To: </b> {{ renderDate(exportFile.filterJson.before) }} </span>
      </td>
      <td data-label="Count">
        {{ (exportFile.count) ? exportFile.count : '...' }}
      </td>
    </tr>
  </tbody>
</table>
  </div>
  <div class="five wide column centered" style="background: #f5f5f5;">

  <div style="margin-bottom: 1rem;" class="ui fluid input">
    <input style="border: none;" v-model="file.name" @input="filterInput" type="text" placeholder="File name">
  </div>

<div @click="download()" class="ui fluid teal button">Download .CSV File</div>

<div class="ui divider"></div>

<div style="margin-top: 0; padding-top: 0;" class="ui basic segment">


  <div class="ui form">
  <h5 class="ui header filtering">Date</h5>
  <span style="display: inline-block; background: #e5e5e5; color: #aaa; font-size: 10px; padding: 0px 5px; border-radius: 3px 3px 0 0; font-weight: bold; margin-bottom: -2px;">FROM :</span>
    <datetime style="position:relative;" :max-datetime="currentDate" v-model="startDate" :type="'datetime'" input-id="startDate">
      <i style="position: absolute;right: 6px;top: 10px; color: #ddd; z-index:1;" for="startDate" slot="before" class="calendar alternate outline icon"></i>
        <template slot="button-confirm" slot-scope="scope" >
        <span style="display: block; padding: 5px 9px; background: #f1f1f1;" @click="updateTime()">Update</span>
        </template>
    
    </datetime>
    <div style="height:10px;"></div>

  <span style="display: inline-block; background: #e5e5e5; color: #aaa; font-size: 10px; padding: 0px 5px; border-radius: 3px 3px 0 0; font-weight: bold; margin-bottom: -2px;">TO :</span>
    <datetime style="position:relative;" :min-datetime="startDate" :max-datetime="currentDate" v-model="endDate" :type="'datetime'"  input-id="endDate">
      <i style="position: absolute;right: 6px;top: 9px; color: #ddd; z-index:1;" for="endDate" slot="before" class="calendar alternate outline icon"></i>
        <template slot="button-confirm" slot-scope="scope" >
          <span style="display: block; padding: 5px 10px; background: #f1f1f1;" @click="updateTime()">Update</span>
        </template>
    </datetime>
  </div>  


<div v-for="group in menu" :key="group.title">
   <div v-if="group.type == 'radio' && group.title == 'Status'" class="radioButtonGroup">
    <h5 class="ui header filtering">{{ group.title }}</h5>
    <div v-for="item in group.data" :key="item.name" @click="item.setFilter()" class="radioButtonInput">
      <div :class="item.isActive(item)" class="radioButton">
        <div class="selectedDot"></div>
      </div>
      <div class="radioButtonLabel">{{item.name}}</div>
    </div>
  </div>


   <div v-if="group.type == 'radio' && group.title == 'Order by' && getUser.email.includes('wise')" class="radioButtonGroup">
    <h5 class="ui header filtering">{{ group.title }}</h5>
    <div v-for="item in group.data" :key="item.name" @click="item.setFilter()" class="radioButtonInput">
      <div :class="item.isActive(item)" class="radioButton">
        <div class="selectedDot"></div>
      </div>
      <div class="radioButtonLabel">{{item.name}}</div>
    </div>
  </div>

<!--   <div v-if="group.type == 'select' && group.title == 'Filtering'">
    <h5 class="ui header filtering">{{ group.title }}</h5>
    <div v-for="item in group.data" :key="item.name" @click="item.setFilter()" style="position: relative;" class="checkboxInput">
      <div v-if="item.disabled" style="top: 0; left: 0; right: 0; bottom: 0; position: absolute; z-index: 999999999; background: rgba(238, 238, 238, 0.95);"></div>
      <div :class="item.isActive()" class="checkbox">
        <i class="icon-check check icon"></i>
      </div>
      <div style="position: relative;" class="checkboxLabel">
          <span style="display: inline-block;"><i :class="item.icon"></i> {{item.name}}</span>
        </div>
    </div>
  </div> -->

  <div v-if="group.type == 'select' && group.title == 'Channels'" style="margin-bottom: 2rem;">
    <h5 class="ui header filtering">{{ group.title }}</h5>
    <div v-for="item in group.data()"  :key="item._id" v-show="(item.visibility !== false)" >
      <div @click="item.setFilter()" class="checkboxInput">
      <div :class="item.isActive()" class="checkbox">
        <i class="icon-check check icon"></i>
      </div>
        <div style="position: relative;" class="checkboxLabel">

          <span v-if="item._type == 'All Channels'" style="display: inline-block;"><i :class="item.icon"></i> {{item.name}}</span>

        <img v-if="item._type == 'channel'" style="margin-right: 4px; width: 24px; border-radius: 7px; vertical-align: middle;" :src="item.avatar"> 
          <img v-if="item._type == 'channel'" :src="getPlatformImage(item.platform)" style="bottom: -5.5px;width: 16px;height: 16px;border-radius: 20px;vertical-align: middle;position: absolute;left: -5.5px;border: 1px solid #fff;" alt="">
          <span v-if="item._type == 'channel'" style="display: inline-block;">{{item.name}} <span style="display: none;">{{ item._id }}</span> </span>
          <span v-if="item._type == 'channel' && item.reAuth().active" :class="'reAuth reAuth-'+ item.reAuth().id" style="font-size: 17px;" >⚠️</span>
        </div>
      </div>
    </div>
  </div>

  <div v-if="group.type == 'select' && group.title == 'Tags'">
    <h5 class="ui header filtering">Message Types</h5>
      <div v-for="item in group.data()" :key="item._id" class="ui small label inboxFilter"  v-on:click.stop="item.setFilter()" :class="item.isActive()" style="margin-bottom: 5px; cursor:pointer;" v-show="(item.messageType && !item.messageIsDm) && item.visibility !== false" >
          <input v-if="item.isActive()" style="margin-right:4px;" type="checkbox" :checked="item.isActive()">
              {{item.name}}
      </div>
      <div class="ui mini info message">If you do not select <b>Ads Comments</b> then every ads and normal comments will be included in CSV.</div>
  </div> 
  
  <div v-if="group.type == 'select' && group.title == 'Tags'">
    <h5 class="ui header filtering">{{ group.title }} 
      <span  @click="tagsFilteringLogic = '_and' " :class="(tagsFilteringLogic == '_and') ? 'ui mini label active' : 'ui mini label' " style="cursor: pointer; font-size: 12px; font-style: italic; font-weight: 100;">AND logic</span>
      <span @click="tagsFilteringLogic = '_or' " :class="(tagsFilteringLogic == '_or') ? 'ui mini label active' : 'ui mini label'" style="cursor: pointer; font-size: 12px; font-style: italic; font-weight: 100;" >OR logic</span>
    </h5>
   
    <div class="ui mini info message">When selecting multiple tags, the filter will display comments that have all of the chosen tags (AND logic), not any of the chosen tags.</div>

      <div v-for="item in group.data()" :key="item._id" class="ui small label inboxFilter"  v-on:click.stop="item.setFilter()" :class="item.isActive()" style="margin-bottom: 5px; cursor:pointer;" :style="{'background': item.color}" v-show="!item.messageType && !item.archived && !item.ratingsMenu" >
          <input v-if="item.isActive()" style="margin-right:4px;" type="checkbox" :checked="item.isActive()">
              {{item.name}}
      </div>
  </div> 

</div>

</div>
  </div>
</div>

</template>


<style scoped>

/deep/ .vdatetime-popup__actions__button {
    padding: 0px 0px !important;
}

/deep/ .vdatetime-input{
  border: 2px solid #e5e5e5 !important;
  border-radius: 0 5px 5px 5px !important;
}
/deep/ .vdatetime-input:hover{
  cursor: pointer;
  background: #f1f1f1;
}

.item.export .description {
  padding: 10px 20px;
}

h5.ui.header.filtering{
  margin-top:1rem;
}

.inbox {
    overflow-y: scroll;
}
.inbox:hover {
    overflow-y: scroll;
    overflow-y: overlay;
}

.radioButtonGroup {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
     flex-direction: column; 
    -webkit-box-align: start;
    align-items: flex-start;
}

.radioButtonInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.radioButtonGroup .radioButtonInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.radioButtonInput {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
}

.radioButtonGroup .radioButtonInput .radioButton.selected {
    border: 2px solid #3960BD;
}

.radioButtonGroup .radioButtonInput .radioButton {
    position: relative;
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    cursor: pointer;
    border-radius: 18px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    }

    .radioButtonGroup .radioButtonInput .radioButtonLabel {
    cursor: pointer;
    padding: 0 10px;
    font-size: 14px;
    line-height: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radioButtonGroup .radioButtonInput .radioButton.selected .selectedDot {
    background: #3960BD;
    opacity: .8;
}

.radioButtonGroup .radioButtonInput .radioButton .selectedDot {
    width: 7px;
    height: 7px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #aaa;
    opacity: 0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    transform: translate(-50%, -50%);
    border-radius: 7px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.radioButtonGroup .radioButtonInput:hover .radioButton.selected .selectedDot {
    opacity: .8;
}

.radioButtonGroup .radioButtonInput:hover .radioButton .selectedDot {
    opacity: .3;
}

.checkboxInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.checkboxInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.checkboxInput .checkbox {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-width: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    border-radius: 5px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    position:relative;
}

.checkboxInput .checkbox .icon-check {
    font-size: 10px;
    color: #aaa;
    opacity: 0;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    -webkit-transform: translate(18%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    bottom: 25%;
    height: 12px;
    top: 25%;
}
.checkboxInput .checkboxLabel {
  position: relative;
    margin: 0 10px;
    font-size: 14px;
    line-height: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
    opacity: .3;
}

.checkboxInput .checkbox.checked .icon-check {
    color: #3960BD;
    opacity: 1;
}

.checkboxInput .checkbox.checked {
    border-color: #3960BD;
}

.filterItem {
  border: 1px solid #f1f1f1;
  background: #f6f6f6;
  border-radius: 3px;
  transition: .3s;
}
/* .filterItem:hover {
  background: #f9f9f9; 
  border: 1px solid #e9e9e9;
  border-radius: 3px;
  transition: .1s;
} */
.filterItem:hover {
  background: #f2f6ff; 
  border: 1px solid #3960bd4d;
  border-radius: 3px;
  transition: .1s;
}
.filterItem.active {
  background: #f2f6ff; 
  border: 1px solid #3960bd4d;
  border-radius: 3px;
}
.ui.label.inboxFilter{
      border: 1px solid transparent !important;
}
.ui.label.inboxFilter:hover{
      background: #f2f6ff !important; 
      border: 1px solid #3960bd4d !important;
      color: #444444 !important;
}
.ui.label.inboxFilter.active{
      background: #f2f6ff !important; 
      border: 1px solid #3960bd4d !important;
      color: #444444 !important;
}


#startDate:hover {
    color: #111; 
}
#endDate:hover {
    color: #111; 
}

#startDate{
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  border: none;
  background: #f9f9f9;
  color: #777;
  position:relative;
  font-style: italic;
}
#endDate{
  border-left: none;
  border-bottom: none;
  border-right: none;
  border-top: 1px solid #f1f1f1;
  background: #f9f9f9;
  color: #777;
  border-radius: 0 0 5px 5px;
  cursor: pointer;
  position:relative;
  font-style: italic;
}

.vdatetime:first-child{
  border-radius: 10px 10px 0 0 ;
}
.vdatetime:last-child{
  border-radius: 0 0 10px 10px ;
}

</style>





// WEBPACK FOOTER //
// src/components/dashboard/export.vue